export type SkeletonProps = {
  className: string
  square?: boolean
}

export const Skeleton: React.FC<SkeletonProps> = ({ className, square, ...rest }) => {
  return (
    <div
      {...rest}
      className={className + ` ${square ? 'rounded-none' : 'rounded-full'} bg-semantic-global-neutral-lighter animate-pulse`}
    />
  )
}
